// extracted by mini-css-extract-plugin
export default {"Options":"RemoveLawListGroupModal_Options__27Wck"};